"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_CANCEL_MESSAGE = 'Upload canceled by user';
exports.CHUNK_FILE_SIZE = 52428800; // 50MB
exports.SUPPORTED_IMAGE_FORMATS = ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'tiff', 'tif', 'pdf'];
exports.SUPPORTED_VIDEO_FORMATS = [
    'mp4',
    'm4v',
    'x-m4v',
    'mov',
    'quicktime',
    'avi',
    'mpeg',
    'mpg',
    '3gp',
    '3gpp',
    '3g2',
    '3gpp2',
    'web',
    'flv',
    'x-flv',
    'rm',
    'vnd.rn-realmedia',
    'mxf',
    'wmv',
    'x-ms-wmv',
    'webm',
    'x-msvideo',
];
exports.ERROR_CODES = {
    CANCELED_BY_USER: '9000',
    VIDEO_FILE_NOT_VALID: '10810',
    VIDEO_ASPECT_RATIO_NOT_SUPPORTED: '10820',
    VIDEO_WIDTH_MAX: '10830',
    VIDEO_WIDTH_MIN: '10840',
    VIDEO_HEIGHT_MAX: '10850',
    VIDEO_HEIGHT_MIN: '10860',
    VIDEO_FILESIZE_MAX: '10870',
    VIDEO_FILESIZE_MIN: '10880',
    VIDEO_DURATION_MAX: '10890',
    VIDEO_DURATION_MIN: '10900',
    VIDEO_EXTENSION_NOT_SUPPORTED: '10910',
    INVALID_IMAGE_FILE: '11030',
    IMAGE_ASPECT_RATIO_NOT_SUPPORTED: '11035',
    IMAGE_WIDTH_MAX: '11040',
    IMAGE_WIDTH_MIN: '11045',
    IMAGE_HEIGHT_MAX: '11050',
    IMAGE_HEIGHT_MIN: '11055',
    IMAGE_FILESIZE_MAX: '11060',
    IMAGE_FILESIZE_MIN: '11065',
    MEDIA_EXTENSION_NOT_SUPPORTED: '11070',
};
